import { Elements } from '@stripe/react-stripe-js'
import { useState } from 'react'

import { stripePromise } from '@/components/BuildingDashboard/Rewards/helpers'

import { ExtendParkingDurationForm } from './extend-parking-duration-form'
import { ExtendParkingPayment } from './extend-parking-payment'
import { ExtendParkingPaymentError } from './extend-parking-payment-error'
import { ParkingSession } from './parking-session'
import {
  EXTEND_VISITOR_PARKING_SCREENS,
  ExtendVisitorParkingScreens,
  VISITOR_PARKING_CURRENCY,
} from './visitor-parking.constants'
import * as S from './visitor-parking.page.styled'
import { useVisitorParkingStore } from './visitor-parking.store'

interface ExtendVisitorParkingRendererProps {
  screen: ExtendVisitorParkingScreens
  setScreen: (screen: ExtendVisitorParkingScreens) => void
}

const ExtendVisitorParkingRenderer = ({ screen, setScreen }: ExtendVisitorParkingRendererProps) => {
  const { paymentSession } = useVisitorParkingStore()

  switch (screen) {
    case EXTEND_VISITOR_PARKING_SCREENS.SESSION_DETAILS:
      return (
        <ParkingSession
          onExtendSession={() => setScreen(EXTEND_VISITOR_PARKING_SCREENS.EXTEND_DURATION)}
        />
      )
    case EXTEND_VISITOR_PARKING_SCREENS.EXTEND_DURATION:
      return (
        <ExtendParkingDurationForm
          onBack={() => setScreen(EXTEND_VISITOR_PARKING_SCREENS.SESSION_DETAILS)}
          onNext={() => setScreen(EXTEND_VISITOR_PARKING_SCREENS.PAYMENT)}
        />
      )
    case EXTEND_VISITOR_PARKING_SCREENS.PAYMENT:
      if (!paymentSession) return null

      return (
        <Elements
          options={{
            amount: paymentSession.amount,
            currency: VISITOR_PARKING_CURRENCY,
            mode: 'payment',
          }}
          stripe={stripePromise}
        >
          <ExtendParkingPayment
            onBack={() => setScreen(EXTEND_VISITOR_PARKING_SCREENS.EXTEND_DURATION)}
            onPaymentError={() => setScreen(EXTEND_VISITOR_PARKING_SCREENS.PAYMENT_ERROR)}
          />
        </Elements>
      )
    case EXTEND_VISITOR_PARKING_SCREENS.PAYMENT_ERROR:
      return (
        <ExtendParkingPaymentError
          onRetryPayment={() => setScreen(EXTEND_VISITOR_PARKING_SCREENS.EXTEND_DURATION)}
        />
      )
    default:
      return null
  }
}

export const ExtendVisitorParking = () => {
  const [screen, setScreen] = useState<ExtendVisitorParkingScreens>(
    EXTEND_VISITOR_PARKING_SCREENS.SESSION_DETAILS,
  )

  return (
    <S.Container>
      <ExtendVisitorParkingRenderer screen={screen} setScreen={setScreen} />
    </S.Container>
  )
}
